import { render, staticRenderFns } from "./vrv-air.vue?vue&type=template&id=c8625e08&scoped=true&"
import script from "./vrv-air.vue?vue&type=script&lang=js&"
export * from "./vrv-air.vue?vue&type=script&lang=js&"
import style0 from "./vrv-air.vue?vue&type=style&index=0&id=c8625e08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8625e08",
  null
  
)

export default component.exports